"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutocompleteSelector = void 0;
const react_1 = __importStar(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const Autocomplete_1 = require("@mui/material/Autocomplete");
const autocomplete_selector_styles_1 = require("./autocomplete-selector.styles");
const utils_1 = require("../../enrich-ai/utils");
const localization_1 = require("../../localization");
const getAutocompleteOptionKey = (option) => {
    const { group: maybeGroup = '', label: maybeLabel = '', value, } = option;
    const group = typeof maybeGroup === 'string' ? maybeGroup : '';
    const label = typeof maybeLabel === 'string' ? maybeLabel : '';
    if (typeof value === 'string' || typeof value === 'number') {
        return `${group}:${String(value)}`;
    }
    if (typeof value === 'symbol') {
        return `${group}:${value.toString()}`;
    }
    try {
        return `${group}:${JSON.stringify(value)}`;
    }
    catch (_a) {
        return `${group}:${label}`;
    }
};
const isOptionEqualToValue = (option, value) => (getAutocompleteOptionKey(option) === getAutocompleteOptionKey(value));
const AutocompleteSelector = ({ options, onChange, selected, placeholder, groupBy, className, error, errorMessage, isLoading, noOptionsText, allowCreation, onBlur, }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const [inputValue, setInputValue] = (0, react_1.useState)('');
    const filter = (0, Autocomplete_1.createFilterOptions)();
    const handleInputChange = (_e, newValue, _reason) => {
        setInputValue(newValue);
    };
    const handleChange = (_e, option, _reason, _details) => {
        var _a;
        const selectedOption = Array.isArray(option) ? option[0] : option;
        if (selectedOption === null || selectedOption === undefined) {
            return;
        }
        if (typeof selectedOption === 'string') {
            setInputValue(String(selectedOption));
            onChange(selectedOption);
            return;
        }
        const normalizedOption = selectedOption;
        setInputValue((_a = normalizedOption === null || normalizedOption === void 0 ? void 0 : normalizedOption.label) !== null && _a !== void 0 ? _a : '');
        if (selectedOption) {
            onChange(normalizedOption.value);
        }
    };
    const renderFilterOptions = (options, params) => {
        const filtered = filter(options, params);
        const { inputValue } = params;
        const isExisting = options.some((option) => (0, utils_1.areEqualCaseInsensitive)(inputValue, option.label));
        if (inputValue && !isExisting) {
            filtered.push({
                value: inputValue,
                label: `${String(t({ key: 'CREATE_NEW' }))} "${inputValue}"`,
            });
        }
        return filtered;
    };
    const selectedOption = options.find((option) => option.value === selected);
    const derivedInputValue = inputValue || (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label) || '';
    return (react_1.default.createElement(autocomplete_selector_styles_1.StyledAutocompleteSelector, { background: ui_components_1.baseColors.white, InputProps: { placeholder }, onChange: handleChange, onInputChange: handleInputChange, inputValue: derivedInputValue, options: options, value: selectedOption !== null && selectedOption !== void 0 ? selectedOption : null, variant: 'outlined', selectOnFocus: true, groupBy: groupBy, getOptionKey: getAutocompleteOptionKey, isOptionEqualToValue: isOptionEqualToValue, className: className, error: error, errorMsg: errorMessage, onBlur: onBlur, loading: isLoading, filterOptions: allowCreation ? renderFilterOptions : undefined, noOptionsText: noOptionsText }));
};
exports.AutocompleteSelector = AutocompleteSelector;
exports.default = exports.AutocompleteSelector;
